import httpStatus from 'http-status'
import Request from '@hotmart-org-ca/request'

import AuthService from 'modules/auth/service'
import { RequestError } from 'common/types'
import { isClub } from '../interceptor'

export default class RequestHelper {
  static errorHandling = (exceptionError: unknown) => {
    const error = exceptionError as RequestError
    const status = error?.response?.status

    if (status === httpStatus.NOT_FOUND) {
      location.href = `/404`
    } else if (status === httpStatus.FORBIDDEN) {
      location.href = `/403`
    }

    return error
  }

  static handleUnauthorizedError = () => {
    AuthService.clear()
    AuthService.logoutUser()

    AuthService.logout()
  }

  static setInterceptors = () => {
    const responseInterceptorSuccess = (response: unknown) => response
    const responseInterceptorError = (exceptionError: unknown) => {
      const error = exceptionError as RequestError
      const status = error?.response?.status ?? 0

      if (isClub() && status === httpStatus.UNAUTHORIZED) {
        RequestHelper.handleUnauthorizedError()
      }

      return Promise.reject(error)
    }

    Request.setResponseInterceptor(
      responseInterceptorSuccess,
      responseInterceptorError
    )
  }
}
